import { render } from "./PicturesUploader.vue?vue&type=template&id=48186c81&scoped=true"
import script from "./PicturesUploader.vue?vue&type=script&lang=js"
export * from "./PicturesUploader.vue?vue&type=script&lang=js"

import "./PicturesUploader.vue?vue&type=style&index=0&id=48186c81&lang=scss"
import "./PicturesUploader.vue?vue&type=style&index=1&id=48186c81&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48186c81"]])

export default __exports__